import { LucideIcon } from 'lucide-react';
import * as LucideIcons from 'lucide-react';

import { IconName, icons } from '../../icons';

export interface IconProps {
  icon: string;
  isCustom?: boolean;
  size?: number;
  color?: string;
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
  height?: number;
}

export const Icon = ({
  icon,
  isCustom = false,
  size = 24,
  color = 'currentColor',
  style,
  ...props
}: IconProps) => {
  if (isCustom) {
    const CustomIcon = icons[icon as IconName];

    if (!CustomIcon) {
      console.warn(`Custom icon "${icon}" not found`);
      return null;
    }

    return (
      <CustomIcon
        width={size}
        height={size}
        fill={color}
        style={style}
        {...props}
      />
    );
  }

  const LucideIconComponent = LucideIcons[
    icon as keyof typeof LucideIcons
  ] as LucideIcon;
  if (!LucideIconComponent) {
    console.warn(`Lucide icon "${icon}" not found`);
    return null;
  }

  return (
    <LucideIconComponent
      className={props.className}
      size={size}
      color={color}
      style={style}
      {...props}
    />
  );
};
